import { AgxFileUpload } from '@urbanx/agx-ui-components'
import {
  AgxButton,
  AgxModal,
  AgxRadioGroup,
  AgxSpacer,
  AgxToggleSwitch,
  AgxTypography,
} from '@urbanx/agx.ui-components2'
import { useMarkedAsExchange } from './useMarkedAsExchange'
import { GeneratedDocumentTypes } from '@urbanx/agx.campaigns.client'
import { useSelectedCampaign } from 'hooks'
import { deleteFile, getFileLink } from 'services'
interface Props {
  controller: ReturnType<typeof useMarkedAsExchange>
}

const MarkedAsExchange = ({ controller }: Props) => {
  const {
    getAuthToken,
    exchangeLetterFiles,
    isConfirmDisabled,
    isOpen,
    isSolicitorExchange,
    selectedOption,
    setIsDialogOpen,
    setSelectedOption,
    setUrbanXisNoted,
    urbanXisNoted,
    onUploadFile,
    closeModal,
    onConfirm,
    onExchangeLetterChanged,
    onSignedContractChanged,
    signedContractFiles,
  } = controller

  const { campaign: selectedCampaign } = useSelectedCampaign();

  return (
    <AgxModal
      type={'single'}
      actionButtons={[
        <AgxButton
          key={'btnCancel'}
          id={'btnCancel'}
          text={'Cancel'}
          variant={'hollow'}
          onClick={closeModal}
          stretch
        />,
        <AgxButton
          key={'btnCancel'}
          id={'btnCancel'}
          text={'Confirm'}
          variant={'primary'}
          disabled={isConfirmDisabled}
          onClick={() => onConfirm(selectedCampaign?.campaignId || '')}
          stretch
        />,
      ]}
      secondaryTitle={
        <AgxSpacer direction="vertical" gap={'spacing-lg'}>
          <AgxTypography
            id="agx-modal-title"
            size="medium"
            type="body_ui_strong"
            dataTestId={`agx-modal-markasexchanged`}
            color="var(--text-primary)"
          >
            {'Mark as Exchanged'}
          </AgxTypography>
          <AgxTypography
            id="agx-modal-title"
            size="small"
            type="body_ui"
            dataTestId={`agx-modal-markasexchanged`}
            color="var(--text-secondary)"
          >
            {'Please upload the following files to process'}
          </AgxTypography>
        </AgxSpacer>
      }
      variant={'withDivider'}
      actionButtonContainerStyle={'withDivider'}
      setIsDialogOpen={setIsDialogOpen}
      isOpen={isOpen}
      content={
        <AgxSpacer
          direction="vertical"
          padding={{ top: 'md', bottom: 'md', left: 'xl', right: 'xl' }}
          gap={'md'}
        >
          <AgxSpacer direction="vertical" gap={'spacing-lg'}>
            <AgxFileUpload
              id="fileUpload"
              title="Upload the Exchange Letter *"
              documentType={GeneratedDocumentTypes.ExchangeLetter}
              buttonText={'Choose file'}
              fileData={exchangeLetterFiles}
              onValueChanged={onExchangeLetterChanged}
              getAuthToken={getAuthToken}
              campaignId={selectedCampaign?.campaignId || ''}
              uploadFile={onUploadFile}
              deleteFile={deleteFile}
              getFileLink={getFileLink}
              extensions={['pdf']}
              multiple={false}
              autoUpload={false}
              required
            />
          </AgxSpacer>
          {isSolicitorExchange && (
            <AgxRadioGroup
              id={'signedContractYesNo'}
              layout={'vertical'}
              options={[
                {
                  label: 'Yes',
                  value: 'Yes',
                },
                {
                  label: 'No',
                  value: 'No',
                },
              ]}
              label="Have you got a Signed Contract *"
              onChange={(option) => setSelectedOption(option)}
              subContent={
                selectedOption === 'Yes' ? (
                  <AgxSpacer
                    fill
                    direction="vertical"
                    gap={'spacing-xl'}
                    padding={{
                      top: 'spacing-2xl',
                      bottom: 'spacing-2xl',
                      left: 'spacing-lg',
                      right: 'spacing-lg',
                    }}
                  >
                    <AgxSpacer
                      fill
                      direction="horizontal"
                      contentJustification="space-between"
                    >
                      <AgxTypography
                        id="agx-modal-lblUpoadLetter"
                        size="medium"
                        type="body_ui"
                        dataTestId={`agx-modal-lblUpoadLetter`}
                        color="var(--text-primary)"
                      >
                        {'Confirm URBAN X is noted on the Contract'}
                      </AgxTypography>
                      <AgxToggleSwitch
                        id={'switch'}
                        checked={urbanXisNoted}
                        onChange={(checked) => setUrbanXisNoted(checked)}
                      />
                    </AgxSpacer>
                    <AgxSpacer direction="vertical" gap={'spacing-lg'}>
                      <AgxFileUpload
                        id="fileUpload"
                        title="Signed Contract *"
                        documentType={GeneratedDocumentTypes.SignedContract}
                        buttonText={'Choose file'}
                        fileData={signedContractFiles}
                        onValueChanged={onSignedContractChanged}
                        getAuthToken={getAuthToken}
                        campaignId={selectedCampaign?.campaignId || ''}
                        uploadFile={onUploadFile}
                        deleteFile={deleteFile}
                        getFileLink={getFileLink}
                        extensions={['pdf']}
                        multiple={false}
                        autoUpload={false}
                        required
                      />
                    </AgxSpacer>
                  </AgxSpacer>
                ) : undefined
              }
              value={undefined}
            ></AgxRadioGroup>
          )}
        </AgxSpacer>
      }
    ></AgxModal>
  )
}

export default MarkedAsExchange
